import React from 'react';
import { SidebarLink } from '../SidebarLink/SidebarLink';
import { Icon } from '../../Icon/Icon';
import { SelectableList } from '../../SelectableList/SelectableList';
import { Avatar } from '../../Avatar/Avatar';
import { history } from '../../../model/history';
import { companyPath } from '../../../routes';
import { t } from '../../../locales/translate';

import './SidebarGroups.css';
import { useSelectedMembership, selectMembership, useSessionMemberships } from '../../../model/membership';
import { Tooltip } from '../../Tooltip/Tooltip';

function iconForPath({ path, name }: { path?: string; name: string }): React.ReactNode {
  if (!path) {
    return <Avatar name={name} />;
  }
  return <img className="icon" src={path} alt="" />;
}

export function SidebarGroups(): JSX.Element {
  const groups = useSessionMemberships();
  const selectedGroup = useSelectedMembership();

  const formattedGroups = groups?.map((group) => {
    return (
      <div key={group.id} className="sidebar-groups__option">
        {group.company.icon && (
          <div className="sidebar-groups__option-icon">
            {iconForPath({
              path: group.company.icon.url || '',
              name: group.company.name || '',
            })}
          </div>
        )}
        <div className="sidebar-groups__option-text">{group.company.name}</div>
      </div>
    );
  });

  return (
    <div className="sidebar-groups">
      <header className="sidebar-groups__header">
        <div className="sidebar-groups__title">{t.model.company.currentCompany}</div>
        <div
          onClick={() => {
            if (selectedGroup) {
              history.push(companyPath(selectedGroup.company));
            }
          }}
          className="sidebar-groups__actions"
        >
          <Icon name="settings" />
        </div>
      </header>
      <div>
        <SidebarLink
          link={
            selectedGroup
              ? {
                  text: selectedGroup.company.name || '',
                  icon: iconForPath({
                    path: selectedGroup.company.icon ? selectedGroup.company.icon.url : '',
                    name: selectedGroup.company.name || '',
                  }),
                }
              : { text: '' }
          }
          actions={[
            <Tooltip
              key="sidebar-groups-header__dropwdown-arrow"
              position="bottom-end"
              arrow={false}
              gap="medium"
              rounded={false}
              mode="click"
              className="sidebar-groups__context-menu"
              reference={<Icon name="arrow-triangle-down" />}
              closeOnChildrenClick={true}
            >
              <SelectableList
                options={formattedGroups}
                onSelect={(index) => {
                  selectMembership(groups[index].id);
                }}
              />
            </Tooltip>,
          ]}
        />
      </div>
    </div>
  );
}
